/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.


import EndUserIdentity from 'components/customer/EndUserIdentity'
import moment from 'moment'
import { captureExceptions } from 'utils/SentryHelpers'
import TagList from 'components/TagList'

import PropTypes from 'prop-types'

import 'styles/components/GlobalSearch/ResultPreview/User.styl'

const ResultPreviewUser = React.createClass({
  displayName: 'ResultPreviewUser',

  propTypes() { return {
    endUser: PropTypes.object.isRequired,
    companies: PropTypes.object.isRequired
  } },

  render() {
    return (
      <div className="ResultPreviewUser">
        <EndUserIdentity endUser={this.props.endUser} />
        {((this.props.companies[this.props.endUser.customerId] != null ? this.props.companies[this.props.endUser.customerId].name : undefined) != null) ?
          <div className="organization">
            <span>
              {`Works for ${this.props.companies[this.props.endUser.customerId].name}`}
            </span>
          </div> : undefined}
        {!_.isEmpty(this.props.endUser.tags) ?
          <div className="tag-list">
            <TagList tagIds={this.props.endUser.tags} />
          </div> : undefined}
      </div>
    )
  }
})

export default Marty.createContainer(ResultPreviewUser, {
  listenTo: ['stores.CompanyStore'],

  fetch: {
    companies() {
      return this.app.stores.CompanyStore.fetchCompanies([this.props.endUser.customerId])
    }
  },

  failed(errors) {
    captureExceptions(errors)
    return <div />
  }
})





// WEBPACK FOOTER //
// ./src/scripts/components/GlobalSearch/ResultPreview/User.js